import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  SearchTermsUsedData,
  SearchTermUsedData,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { SearchTermsConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "top-search-terms-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class TopSearchTermsChartComponent
  extends BaseChartLogic<SearchTermsConfig, SearchTermsUsedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      SearchTermsConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.searchTermsUsedDataChange
    );
  }

  getCustomLabel(dataPoint: SearchTermUsedData, label: string): any {
    if (label === "Document Count") {
      return Array.isArray(dataPoint.DocumentsSearched)
        ? dataPoint.DocumentsSearched.length
        : 0;
    }

    if (label !== "Documents") {
      return "";
    }

    const documents = dataPoint.DocumentsSearched;
    const customLabelSelection = this.config?.customLabelSelection?.length
      ? this.config.customLabelSelection
      : this.chartDetails.customLabels["Documents"];

    const result_asTable: any[] = [];
    documents.forEach((user) => {
      const row = {};
      customLabelSelection.forEach((selection) => {
        row[selection] = this.resolveDeepPath(user, selection);
      });
      result_asTable.push(row);
    });
    return result_asTable;
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(dataPoint: SearchTermUsedData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.FilterByMinimum = this.config?.minUsed || null;
    //this.filterSettings.LimitResults = this.config?.top || null;
  }

  refreshData(): void {
    this.analyticsService.getSearchTermsUsedData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
